import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from 'react';
import '../../styles/game/InfoBoard.css';
import AllBets from './AllBets.jsx';
import MyBets from './MyBets.jsx';
import Top from './Top.jsx';
import { t } from "i18next";

function InfoBoard({ isUserId, ProvablyFairOpen, setIsNotifyOpen }) {
    const [isAllBets, setIsAllBets] = useState(true);
    const [isMyBets, setIsMyBets] = useState(false);
    const [isTop, setIsTop] = useState(false);
    const [isPreviousRound, setIsPreviousRound] = useState(false)
    const sliderRef = useRef(null);

    // useEffect(() => {
    //     if(sliderRef.current) {
    //         if (isAllBets) {
    //             sliderRef.current.style.transform = "translateX(0)";
    //         } else if (isMyBets) {
    //             sliderRef.current.style.transform = "translateX(100px)";
    //         } else if (isTop) {
    //             sliderRef.current.style.transform = "translateX(200px)";
    //         }
    //     }
    // }, [isAllBets, isMyBets, isTop]);

    const handleNavClick = (tab) => {
        setIsAllBets(tab === "allBets");
        // setIsMyBets(tab === "myBets");
        setIsTop(tab === "top");
        setIsPreviousRound(tab === 'previousRound')
    };

    return (
        <>
            <div className={'info-board-wrapper'}>
                <div className={'bets-block'}>
                    <div className={'bets-block-nav'}>
                        <div className={'navigation-switcher'}>
                            {/* <div className={'nav-slider'} ref={sliderRef}></div> */}
                            <button className={`nav-tab ${isAllBets ? "active" : ""}`} onClick={() => handleNavClick('allBets')}>{t("AllBets")}</button>
                            {/* <button className={`nav-tab ${isMyBets ? "active" : ""}`} onClick={() => handleNavClick('myBets')}>{t("MyBets")}</button> */}
                            <button className={`nav-tab ${isPreviousRound ? "active" : ""}`} onClick={() => handleNavClick('previousRound')}>{t("previous")}</button>
                            <button className={`nav-tab ${isTop ? "active" : ""}`} onClick={() => setIsNotifyOpen(true)}>{t("Top")}</button>
                        </div>
                    </div>
                    {(isAllBets || isPreviousRound) && <AllBets isPreviousRound={isPreviousRound} setIsPreviousRound={setIsPreviousRound} />}
                    {/* {isMyBets && <MyBets isUserId={isUserId} />} */}
                    {isTop && <Top />}
                    <div className={'info-board-footer'}>
                    <div className={'provably-fair-block'}>
                        {/* <span>{t("ThisGame")}</span> */}
                        <div className={'info-board-provably-fair'} onClick={ProvablyFairOpen}>
                            <div className={'i-fair'}></div>
                            <span>{t("ProvablyFair")} Game</span>
                        </div>
                    </div>
                    <div className={'powered-logo-wrap'}>
                        
                        <a href="https://spribe.co" target="_blank">
                            <span>Powered by</span>
                            <div className={'spribe-logo'}></div>
                        </a>
                    </div>
                </div>
                </div>


            </div>
        </>
    )
}

export default InfoBoard;